/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechServerIcon16Light } from './TechServerIcon16Light';
import { TechServerIcon16Regular } from './TechServerIcon16Regular';
import { TechServerIcon16Solid } from './TechServerIcon16Solid';
import { TechServerIcon20Light } from './TechServerIcon20Light';
import { TechServerIcon20Regular } from './TechServerIcon20Regular';
import { TechServerIcon20Solid } from './TechServerIcon20Solid';
import { TechServerIcon24Regular } from './TechServerIcon24Regular';
import { TechServerIcon24Solid } from './TechServerIcon24Solid';
import { TechServerIcon32Regular } from './TechServerIcon32Regular';
import { TechServerIcon64Regular } from './TechServerIcon64Regular';
var sizes = {
    16: {
        light: TechServerIcon16Light,
        regular: TechServerIcon16Regular,
        solid: TechServerIcon16Solid,
    },
    20: {
        light: TechServerIcon20Light,
        regular: TechServerIcon20Regular,
        solid: TechServerIcon20Solid,
    },
    24: {
        regular: TechServerIcon24Regular,
        solid: TechServerIcon24Solid,
    },
    32: {
        regular: TechServerIcon32Regular,
    },
    64: {
        regular: TechServerIcon64Regular,
    },
};
export var TechServerIcon = forwardRef('TechServerIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
